<template>
  <div class="min-h-screen flex flex-col">
    <header class="app-header">
      <div class="container">
        <div class="header-content">
          <img
            src="~/assets/images/logo-redbag.png"
            alt="RedBag Logo"
            class="app-logo"
          />
          <h1 class="app-title">REunify</h1>
        </div>
      </div>
    </header>

    <main class="flex-1 px-4 py-4">
      <slot />
    </main>
  </div>
</template>

<style scoped>
  .app-header {
    background-color: var(--primary-color);
    color: white;
    padding: 1rem 0;
  }

  .header-content {
    display: flex;
    align-items: center;
  }

  .app-logo {
    height: 2.5rem;
    margin-right: 1rem;
  }

  .app-title {
    margin: 0;
    font-size: 1.5rem;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
  }

  @media (max-width: 768px) {
    .app-logo {
      height: 2rem;
      margin-right: 0.75rem;
    }

    .app-title {
      font-size: 1.25rem;
    }
  }
</style>
